<template>
  <div class="entry-exit-invoicing-details">
    <div class="row">
      <div class="sub-title">基本信息</div>
      <div class="base-info">
        <div class="base-info-item" v-for="(item, index) in payBaseInfoList" :key="index">
          <div class="base-info-item-label">{{ item.name }}：</div>
          <div class="base-info-item-content">
            <tool-tip v-bind="{ txtInfo: String(baseInfoObj[item.key]) }">
            </tool-tip>
          </div>
        </div>

        <el-form class="base-info-form" ref="baseInfoForm" :model="baseInfoForm" :rules="payBaseInfoRules">
          <el-form-item label="购买方公司：" prop="invoiceCompanyName">
            <el-select class="white" 
              v-model="baseInfoForm.invoiceCompanyName" 
              placeholder="请选择"
              :disabled="status > 11"
              @change="changeInvoiceCompanyName"
            >
              <el-option v-for="(item, index) in bankAccountNumberList" :value="item.companyCode" :label="item.companyName" :key="index">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="银行账户：" prop="invoiceBankAccount">
            <el-input class="white" v-model="baseInfoForm.invoiceBankAccount" disabled
              placeholder="请输入">
            </el-input>
          </el-form-item>
          <el-form-item label="税率：" prop="taxRate">
            <el-select class="white" v-model="baseInfoForm.taxRate" placeholder="请选择" :disabled="status > 11 || limitZeroList.indexOf(baseInfoForm.invoiceType) !== -1">
              <el-option v-for="(item, index) in taxRateList" :value="item.taxRate" :label="item.taxRate" :key="index">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票类型：" prop="invoiceType">
            <el-select class="white" v-model="baseInfoForm.invoiceType" @change="changeInvoiceType" placeholder="请选择" :disabled="status > 11">
              <el-option v-for="(item, index) in payInvoiceTypeList" :value="item.id" :label="item.name" :key="index">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票号：" prop="invoiceNumber">
            <el-input class="white" v-model="baseInfoForm.invoiceNumber" :disabled="status > 11"
              placeholder="请输入">
            </el-input>
          </el-form-item>
          <el-form-item label="发票日期：" prop="invoiceDate">
            <el-date-picker
              v-model="baseInfoForm.invoiceDate"
              type="date"  
              value-format="yyyy-MM-dd"
              :disabled="status > 11"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="发票代码：" prop="invoiceCode">
            <el-input class="white" v-model="baseInfoForm.invoiceCode" :disabled="status > 11"
              placeholder="请输入">
            </el-input>
          </el-form-item>
          <el-form-item label="发票备注：" prop="invoiceMemo">
            <el-input class="white" v-model="baseInfoForm.invoiceMemo" :disabled="status > 11"
              placeholder="请输入">
            </el-input>
          </el-form-item>
          <!-- <el-form-item label="业务日期：" prop="businessDate">
            <el-date-picker
              v-model="baseInfoForm.businessDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :disabled="status > 11"
            ></el-date-picker>
          </el-form-item> -->
        </el-form>
      </div>
    </div>

    <div class="row">
      <div class="sub-title sub-title-between">
        <span>发票明细</span>
        <span v-if="status === 11" class="generate-invoice-details" @click="openGenerateIvoiced">生成发票明细</span>
      </div>

      <div class="table invoice-table">
        <el-table 
          ref="invoiceTable" 
          :data="invoiceTable" 
          style="width: 100%" 
        >
          <el-table-column type="expand" width="30">
            <template slot-scope="props">
              <el-table 
                ref="subjectDetailsTable" 
                class="expand-colum-table" 
                :data="props.row.children" 
                style="width: 100%"
                :summary-method="getSummaries"
                show-summary
              >
                <el-table-column 
                  v-for="(item, index) in subjectDetailsTableTitle" 
                  :label="item.label" 
                  :prop="item.prop"
                  :width="item.width"
                  show-overflow-tooltip
                >
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>

          <el-table-column 
            v-for="(item, index) in invoiceTableTitle" :key="index" show-overflow-tooltip
            :prop="item.prop" :label="item.label"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'name'" class="name">
                <p>{{ scope.row.name }}</p>
              </div>
              <div v-if="item.prop === 'goodsQuantity'" class="nums" :class="(!scope.row.children || status > 11)?'nums-active':''">
                <p v-if="!scope.row.children || status > 11">
                  {{ scope.row.goodsQuantity }}
                </p>
                <el-input v-if="scope.row.children && status === 11" v-model="scope.row.goodsQuantity" class="white" placeholder="请输入"
                  @input="inputNums(scope.$index, scope.row.goodsQuantity)">
                </el-input>
              </div>
              <div v-if="item.prop === 'unitLocalPrice'" class="unit-price" :class="(!scope.row.children || status > 11)?'unit-price-active':''">
                <p v-if="!scope.row.children || status > 11">
                  {{ scope.row.unitLocalPrice }}
                </p>
                <el-input v-if="scope.row.children && status === 11" v-model="scope.row.unitLocalPrice" class="white" placeholder="请输入"
                  @input="inputUnitPrice(scope.$index, scope.row.unitLocalPrice)">
                </el-input>
              </div>
              <div v-if="item.prop === 'totalLocalPrice'" class="total-price" :class="(!scope.row.children || status > 11)?'total-price-active':''">
                <p v-if="!scope.row.children || status > 11">
                  {{ scope.row.totalLocalPrice }}
                </p>
                <el-input v-if="scope.row.children && status === 11" v-model="scope.row.totalLocalPrice" class="white" placeholder="请输入"
                  @input="inputTotalLocalPrice(scope.$index, scope.row.totalLocalPrice)">
                </el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="80">
            <template slot-scope="scope">
              <el-button :disabled="status !== 11" class="btn-text" type="text" @click="saveInvoicingDetails(scope.row)">保存</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="row">
      <div class="sub-title">进出仓单信息</div>
      <div class="table order-table" :class="status === 11?'entry-exit-table':'entry-exit-table-details'">
        <el-table class="entry-table" v-if="status === 11" ref="invoiceTable" :data="entryTable" style="width: 100%">
          <el-table-column 
            v-for="(item, index) in entryTableTitle" 
            :key="index" 
            :prop="item.prop" 
            :label="item.label"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'name'" class="name">
                <p>{{ scope.row.name }}</p>
              </div>
              <div v-if="item.prop === 'serviceProcess'" class="service-process">
                <el-select class="white" v-model="scope.row.serviceProcess" placeholder="请选择">
                  <template slot="prefix">
                    <span v-if="(scope.$index === entryTable.length-1 && entryTable.length>1) || scope.row.serviceProcessType" class="ditto" @click.stop.self="dittoOrdown(scope.$index, scope.row, entryTable, 'serviceProcess', 'serviceProcessType')">同上</span>
                    <span v-if="scope.$index === 0 || !scope.row.serviceProcessType" class="down" @click.stop.self="dittoOrdown(scope.$index, scope.row, entryTable, 'serviceProcess', 'serviceProcessType')">同下</span>
                  </template>
                  <el-option 
                    v-for="(item, index) in serviceProcessList" 
                    :value="item.id" 
                    :label="item.name" 
                    :key="index">
                  </el-option>
                </el-select>
              </div>
              <div v-if="item.prop === 'depotLevelServices'" class="warehouse-services">
                <el-select class="white" v-model="scope.row.depotLevelServices" placeholder="请选择">
                  <template slot="prefix">
                    <span v-if="(scope.$index === entryTable.length-1 && entryTable.length>1) || scope.row.depotLevelServicesType" class="ditto" @click.stop.self="dittoOrdown(scope.$index, scope.row, entryTable, 'depotLevelServices', 'depotLevelServicesType')">同上</span>
                    <span v-if="scope.$index === 0 || !scope.row.depotLevelServicesType" class="down" @click.stop.self="dittoOrdown(scope.$index, scope.row, entryTable, 'depotLevelServices', 'depotLevelServicesType')">同下</span>
                  </template>
                  <el-option 
                    v-for="(item, index) in warehouseServicesList" 
                    :value="item.id" 
                    :label="item.name" 
                    :key="index">
                  </el-option>
                </el-select>
              </div>
              <div v-if="item.prop === 'warehouseCategory'" class="warehouse-category">
                <el-select class="white" v-model="scope.row.warehouseCategory" placeholder="请选择">
                  <template slot="prefix">
                    <span v-if="(scope.$index === entryTable.length-1 && entryTable.length>1) || scope.row.warehouseCategoryType" class="ditto" @click.stop.self="dittoOrdown(scope.$index, scope.row, entryTable, 'warehouseCategory', 'warehouseCategoryType')">同上</span>
                    <span v-if="scope.$index === 0 || !scope.row.warehouseCategoryType" class="down" @click.stop.self="dittoOrdown(scope.$index, scope.row, entryTable, 'warehouseCategory', 'warehouseCategoryType')">同下</span>
                  </template>
                  <el-option 
                    v-for="(item, index) in warehouseCategoryList" 
                    :value="item.id" 
                    :label="item.name" 
                    :key="index">
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
        </el-table>
        
        <el-table v-if="status === 11" ref="invoiceTable" :data="exitTable" style="width: 100%">
          <el-table-column 
            v-for="(item, index) in exitTableTitle" 
            :key="index" 
            :prop="item.prop" 
            :label="item.label"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'name'" class="name">
                <p>{{ scope.row.name }}</p>
              </div>
              <div v-if="item.prop === 'serviceProcess'" class="service-process">
                <el-select class="white" v-model="scope.row.serviceProcess" placeholder="请选择">
                  <template slot="prefix">
                    <span v-if="(scope.$index === exitTable.length-1 && exitTable.length>1) || scope.row.serviceProcessType" class="ditto" @click.stop.self="dittoOrdown(scope.$index, scope.row, exitTable, 'serviceProcess', 'serviceProcessType')">同上</span>
                    <span v-if="scope.$index === 0 || !scope.row.serviceProcessType" class="down" @click.stop.self="dittoOrdown(scope.$index, scope.row, exitTable, 'serviceProcess', 'serviceProcessType')">同下</span>
                  </template>
                  <el-option 
                    v-for="(item, index) in serviceProcessList" 
                    :value="item.id" 
                    :label="item.name" 
                    :key="index">
                  </el-option>
                </el-select>
              </div>
              <div v-if="item.prop === 'depotLevelServices'" class="warehouse-services">
                <el-select class="white" v-model="scope.row.depotLevelServices" placeholder="请选择">
                  <template slot="prefix">
                    <span v-if="(scope.$index === exitTable.length-1  && exitTable.length>1) || scope.row.depotLevelServicesType" class="ditto" @click.stop.self="dittoOrdown(scope.$index, scope.row, exitTable, 'depotLevelServices', 'depotLevelServicesType')">同上</span>
                    <span v-if="scope.$index === 0 || !scope.row.depotLevelServicesType" class="down" @click.stop.self="dittoOrdown(scope.$index, scope.row, exitTable, 'depotLevelServices', 'depotLevelServicesType')">同下</span>
                  </template>
                  <el-option 
                    v-for="(item, index) in warehouseServicesList" 
                    :value="item.id" 
                    :label="item.name" 
                    :key="index">
                  </el-option>
                </el-select>
              </div>
              <div v-if="item.prop === 'warehouseCategory'" class="warehouse-category">
                <el-select class="white" v-model="scope.row.warehouseCategory" placeholder="请选择">
                  <template slot="prefix">
                    <span v-if="(scope.$index === exitTable.length-1  && exitTable.length>1) || scope.row.warehouseCategoryType" class="ditto" @click.stop.self="dittoOrdown(scope.$index, scope.row, exitTable, 'warehouseCategory', 'warehouseCategoryType')">同上</span>
                    <span v-if="scope.$index === 0 || !scope.row.warehouseCategoryType" class="down" @click.stop.self="dittoOrdown(scope.$index, scope.row, exitTable, 'warehouseCategory', 'warehouseCategoryType')">同下</span>
                  </template>
                  <el-option 
                    v-for="(item, index) in warehouseCategoryList" 
                    :value="item.id" 
                    :label="item.name" 
                    :key="index">
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 详情展示表格 -->
        <el-table class="entry-table" v-if="status !== 11" ref="invoiceTable" :data="entryTable" style="width: 100%">
          <el-table-column 
            v-for="(item, index) in entryTableTitle" 
            :key="index" 
            :prop="item.prop" 
            :label="item.label"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
        <el-table v-if="status !== 11" ref="invoiceTable" :data="exitTable" style="width: 100%">
          <el-table-column 
            v-for="(item, index) in exitTableTitle" 
            :key="index" 
            :prop="item.prop" 
            :label="item.label"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    
    <div class="footer">
      <el-button class="btn-white" @click="goBack">
        返回
      </el-button>
      <el-button
        v-if="status === 21"
        class="btn-blue"
        @click="submit"
        >提交</el-button
      >
      <el-button
        v-if="status === 11"
        class="btn-blue"
        @click="verify('baseInfoForm')"
        >核实</el-button
      >
      <el-button v-if="status === 31" class="btn-blue" @click="redChong">
        红冲
      </el-button>
      <el-button v-if="status === 31" class="btn-red" @click="delInvoice">删除</el-button>
      <el-button v-if="status === 11 || status === 21 || status === 41 || status === 80" class="btn-red" @click="revoke">撤销</el-button>
    </div>

    
    <!-- 生成发票明细 -->
    <dialogTransfer
    v-if="generateInvoicedDialog"
    :title="title"
    :accountsType="accountsType"
    :generateInvoicedDialog="generateInvoicedDialog"
    :subjectTableTitle="subjectTableTitle"
    @onCloseGenerateInvoiced="onCloseGenerateInvoiced"
    @onSaveGenerateInvoiced="onSaveGenerateInvoiced"
    ></dialogTransfer>
    
    
    <!-- 是否发起红冲 -->
    <el-dialog 
      class="red-dialog" 
      title="红冲" 
      top="20vh" 
      :visible.sync="redChongDialog"
      width="420px" 
      :before-close="closeRedChong">
      <div class="border"></div>
      <div>
        <el-form class="red-chong-form" ref="redChongForm" :model="redChongForm">
          <el-form-item label="红冲发票号：" prop="redInvoiceNumber">
            <el-input class="white" v-model="redChongForm.redInvoiceNumber"
              placeholder="请输入">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeRedChong"
          >取消</el-button
        >
        <el-button class="btn-blue" @click="confirmRedChong"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { modifyNetTitle } from "common/js/util";
import toolTip from '@/components/base/toolTip.vue'
import dialogTransfer from '@/components/base/inventory-reconciliation/dialog-transfer.vue'
import EntryExitInvoicing from "models/entry-exit-invoicing";
import EntryExitOrderMixins from "common/mixins/entry-exit-invoicing/entry-exit-order";
import EntryExitInvoicingBaseInfoMixins from "common/mixins/entry-exit-invoicing/base-info";
import EntryExitInvoicingInvoicingDetailsMixins from "common/mixins/entry-exit-invoicing/invoicing-details";
export default {
  mixins: [EntryExitInvoicingBaseInfoMixins, EntryExitInvoicingInvoicingDetailsMixins, EntryExitOrderMixins],
  components: {
    toolTip,
    dialogTransfer
  },

  data() {
    return {
      // 1：应收 2:应付
      accountsType: 2,
      // 详情id
      inventoryReconciliationId: null,
      // 提交状态
      status: 11,
      // 生成发票明细弹框开关
      generateInvoicedDialog: false,
      // 弹框标题名称
      title: '生成发票明细',
      // 科目明细表头
      subjectTableTitle: [
        { prop: 'feeName', label: '科目明细', width: ''},
        { prop: 'entryExitNumber', label: '进出仓编号/提单号', width: '180'},
        { prop: 'price', label: '金额', width: ''},
        { prop: 'localPrice', label: '本币金额', width: '120'}
      ],
      redChongForm: {
        // 红冲发票号
        redInvoiceNumber: ''
      },
      redChongDialog: false,
      // 限制税率选择0
      limitZeroList: [
        'ba6215f2e6d601e93806e29fc02a66e7',
        'bf10e4553c857602238055bb4ed59e07',
        'b638989e3eeb391c8fecbed4f373f830',
        'b0c2cfc8c53bb5b223eec7455ca6c915'
      ]
    }
  },

  created() {
    modifyNetTitle('进出仓应付提交详情')
    this.inventoryReconciliationId = Number(this.$route.query.inventoryReconciliationId)
    this.initInvoiceDetails()
  },

  methods: {
    initInvoiceDetails(type) {
      EntryExitInvoicing.getInvoiceDetails(this.inventoryReconciliationId).then(res => {
        if (res.success) {
          let { invoice, invoiceDetailList, 
            invoiceOrderDetailList 
          } = res.result
          this.status = invoice.status
          if (type === 'generate') {
            this.initInvoiceTable(invoiceDetailList)
          } else {
            this.initBaseInfo(invoice)
            this.initInvoiceTable(invoiceDetailList)
            this.initEntryExitTable(invoiceOrderDetailList, invoice.status, 'pay')
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },

    goBack() {
      this.$router.push({
        path: '/finance/cope-with-submission/cope-with-submission-list',
      })
    },
    
    /** 
     * @description 核实
    */
    verify(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.invoiceTable.length === 0) return this.$message.error('请先生成发票明细');

          let invoiceCompanyName = this.baseInfoForm.invoiceCompanyName
          let bankAccount = this.baseInfoForm.invoiceBankAccount
          let bankName = this.baseInfoForm.invoiceBankName
          let taxRate = this.baseInfoForm.taxRate
          let invoiceType = this.baseInfoForm.invoiceType
          let invoiceDate = this.baseInfoForm.invoiceDate
          let invoiceCode = this.baseInfoForm.invoiceCode
          let invoiceNumber = this.baseInfoForm.invoiceNumber
          let invoiceMemo = this.baseInfoForm.invoiceMemo
          let businessDate = this.baseInfoForm.businessDate
          
          let entryExitTable = [...this.entryTable, ...this.exitTable]
          let invoiceOrderDetailList = entryExitTable
          let data = {
            invoiceCompanyName,
            bankAccount,
            bankName,
            invoiceType,
            taxRate,
            invoiceMemo,
            businessDate,
            invoiceCode,
            invoiceNumber,
            invoiceDate,
            invoiceOrderDetailList
          }
          let isFlage = false
          entryExitTable.map(i => {
            if (!i.depotLevelServices) isFlage = true
          })
          if (isFlage) return this.$message.error('请选择仓库服务');
          EntryExitInvoicing.postVerify(this.inventoryReconciliationId, data).then(res => {
            if (res.success) {
              this.initInvoiceDetails()
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /** 
     * @description 提交
    */
    submit() {
      this.$confirm("是否发起提交？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        EntryExitInvoicing.postSubmit(this.inventoryReconciliationId).then(res => {
          if (res.success) {
            this.goBack()
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    /** 
     * @description 撤销
    */
    revoke() {
      this.$confirm("是否发起撤销？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        EntryExitInvoicing.postCancelInvoicing(this.inventoryReconciliationId).then(res => {
          if (res.success) {
            this.goBack()
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    /** 
     * @description 删除发票
    */
    delInvoice() {
      this.$confirm("是否发起删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        EntryExitInvoicing.postDelInvoicing(this.inventoryReconciliationId).then(res => {
          if (res.success) {
            this.goBack()
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    closeRedChong() {
      this.redChongForm.redInvoiceNumber = ''
      this.redChongDialog = false
    },

    confirmRedChong() {
      this.$confirm("是否发起红冲？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let data = {
          redInvoiceNumber: this.redChongForm.redInvoiceNumber
        }
        EntryExitInvoicing.postRedChongInvoicing(this.inventoryReconciliationId, data).then(res => {
          if (res.success) {
            this.initInvoiceDetails()
            this.closeRedChong()
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    /** 
     * @description 红冲
    */
    redChong() {
      this.redChongDialog = true
    },

    openGenerateIvoiced() {
      this.generateInvoicedDialog = true
    },
    
    onCloseGenerateInvoiced() {
      this.generateInvoicedDialog = false
    },

    /** 
     * @description 生成发票明细
     * @param {array} editableTabs 拆分后的发票明细数据
    */
    onSaveGenerateInvoiced(editableTabs) {
      let arr = []
      editableTabs.map(i => {
        let obj = {}
        obj.goodsReceiptId = i.id
        obj.goodsReceiptName = i.goodsReceiptName
        obj.orderFeeDetailIdList = []
        i.subjectTableData.map(j => {
          obj.orderFeeDetailIdList.push(j.id)
        })
        arr.push(obj)
      })
      EntryExitInvoicing.postGenerateInvoicing(this.inventoryReconciliationId, arr).then(res => {
        if (res.success) {
          this.onCloseGenerateInvoiced()
          this.initInvoiceDetails('generate')
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /** 
     * @desc 同上/下方法
     * @param {number} index 当前下标
     * @param {object} row 当前行
     * @param {array} list 当前集合
     * @param {string} key 当前key
     * @param {string} type 当前类型
    */
    dittoOrdown(index, row, list, key, type) {
      if (list.length>1) {
        let item = null
        if (index === 0) {
          item = list[1]
        } else if (index === list.length-1) {
          item = list[list.length-2]
        } else {
          if (list.length>2) {
            if (row[type]) {
              item = list[index-1]
            } else {
              item = list[index+1]
            }
            row[type] = !row[type]
          }
        }
        row[key] = item[key]
      }
    },

    tableRowClassName({ row, column, columnIndex }) {
      if (!row.type && columnIndex === 0) {
        return "error-row";
      } else if (!row.plateNumber&& columnIndex === 1) {
        return "error-row";
      }else if (!row.origin&& columnIndex === 2) {
        return "error-row";
      }else if (!row.destination&& columnIndex === 3) {
        return "error-row";
      }else if (!row.goodsName&& columnIndex === 4) {
        return "error-row";
      }
    },

    changeInvoiceType(id) {
      if (this.limitZeroList.indexOf(id) !== -1) this.baseInfoForm.taxRate = 0
    }
  }
}
</script>

<style lang='scss'>
.entry-exit-invoicing-details {
  .row {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 20px;
    .sub-title {
      height: 52px;
      line-height: 52px;
      border-bottom: 1px solid #eee;
      padding-left: 32px;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
    }
    .sub-title-between {
      display: flex;
      justify-content: space-between;
      padding-right: 22px;
      .generate-invoice-details {
        cursor: pointer;
        font-weight: 400;
        font-size: 14px;
        color: #2E68EA;
        font-family: 'PingFang SC-Regular';
      }
    }
    .el-input.is-disabled .el-input__inner {
      background: #F5F7FA;
      color: #333333;
      font-family: 'PingFang SC-Regular';
      font-weight: 400;
      font-size: 14px;
    }
    .el-select.white .el-input__inner,
    .el-input.white .el-input__inner,
    .el-input.white .el-input__inner:hover {
      border-color: #EBEEF5;
    }
  }

  .row:nth-of-type(3) {
    margin-bottom: 0px;
    border-radius: 8px 8px 0px 0px;
  }

  // 基本信息
  .base-info {
    padding: 20px 32px 30px 32px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 16px;
    column-gap: 16px;
    .base-info-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-family: 'PingFang SC-Regular';
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: #666666;
      .base-info-item-label {
        min-width: 40px;
      }
  
      .base-info-item-content {
        flex: 1;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .write-off {
          width: 14px;
          height: 14px;
          margin-left: 10px;
        }
      }
      .hign-content {
        color: #2E68EA;
      }
    }
    .base-info-form {
      grid-column: 1/-1;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      column-gap: 16px;
      row-gap: 20px;
      margin-top: 4px;
      .el-form-item {
        margin-bottom: 0px;
        .el-select,
        .el-input {
          width: 200px;
        }
        .el-form-item__label {
          width: 100px;
        }
        .el-form-item__error {
          left: 100px
        }
      }
    }
  }

  // 发票明细
  .invoice-table {
    padding: 20px 22px 14px 18px;
    .el-table .el-table__body-wrapper .el-table__body tr td .cell {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 44px;
    }
    .el-table .el-table__header-wrapper .el-table__header tr th:nth-of-type(2) .cell,
    .el-table .el-table__body-wrapper .el-table__body tr td:nth-of-type(2) .cell {
      padding-left: 0px;
    }
    .el-icon-arrow-right:before {
      content: "\E790";
    }
    .el-table__expand-icon--expanded {
      transform: rotate(180deg);
      color: #2E68EA;
    }
    .el-table__indent {
      padding-left: 3px!important;
    }
    .btn-text.is-disabled {
      color: #ccc;
    }
    .nums,
    .unit-price,
    .total-price,
    .bill-total-price {
      p {
        padding-left: 16px;
        color: #333333;
        font-family: 'PingFang SC-Regular';
        font-weight: 400;
        font-size: 14px;
      }
    }
    .nums-active,
    .unit-price-active,
    .total-price-active,
    .bill-total-active {
      p {
        padding-left: 0px;
      }
    }

    // 科目明细
    .el-table__expanded-cell {
      border: 0px;
    }
    .expand-colum-table {
      border-radius: 0px;
      border: 0px;
      .el-table__footer-wrapper .el-table__footer tr td .cell,
      .el-table__body-wrapper .el-table__body tr td .cell,
      .el-table__header-wrapper .el-table__header tr th .cell {
        height: 32px;
      }
      .el-table__footer-wrapper tbody td, .el-table__header-wrapper tbody td {
        background-color: white;
      }
      .el-table__footer-wrapper .el-table__footer tr td .cell {
        font-weight: 800;
        font-size: 14px;
        color: #333333;
        font-family: 'PingFang SC-Medium';
      }
    }
  }

  // 拖车明细
  .trailer-table {
    padding: 20px 22px 21px 18px;
    .el-table .el-table__body-wrapper .el-table__body tr td .cell {
      height: 44px;
      line-height: 44px;
    }
    .el-table .el-table__body-wrapper .el-table__body .close-row td .cell {
      color: #999999;
      font-family: 'PingFang SC-Regular';
      .el-button.mod-btn {
        color: #999999;
        font-size: 14px;
      }
    }
    .el-table .error-row .cell .el-input .el-input__inner,
    .el-table .error-row .cell .el-select .el-input__inner {
      border-color: #F56C6C;
    }
    .add-account {
      width: 100%;
      height: 36px;
      line-height: 36px;
      text-align: center;
      box-sizing: border-box;
      border: 1px dashed #2E68EA;
      font-family: 'PingFang SC-Regular';
      font-weight: 400;
      font-size: 14px;
      color: #2E68EA;
      cursor: pointer;
      margin: 10px 0px 0px 0px;
      .el-icon-plus {
        font-weight: 600;
      }
    }
  }

  // 进出仓单信息
  .entry-exit-table {
    padding: 20px 22px 14px 18px;
    .el-table .el-table__body-wrapper .el-table__body tr td .cell {
      height: 44px;
    }
  }
  .order-table {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    .service-process,
    .warehouse-services,
    .warehouse-category {
      .el-select {
        width: 80%;
        .el-input__inner {
          padding-left: 38px;
        }
        .el-input__prefix {
          width: 29px;
          height: 30px;
          line-height: 30px;
          left: 1px;
          top: 1px;
          background: #F5F7FA;
          border-right: 1px solid #EBEEF5;
          .ditto,
          .down {
            font-family: 'PingFang SC-Regular';
            font-weight: 400;
            font-size: 12px;
            cursor: pointer;
          }
          .ditto {
            color: #2E68EA;
          }
          .down {
            color: #22A979;
          }
        }
      }
    }
    .entry-table {
      margin-right: 20px;
    }
    
    .el-table {
      max-height: 304px;
      overflow: auto;
    }
  }
  .entry-exit-table-details {
    .el-table {
      max-height: 298px;
    }
  }
  .entry-exit-table,
  .entry-exit-table-details {
    padding: 20px 22px 14px 18px;
    .el-table .el-table__body-wrapper .el-table__body tr td .cell {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .nums,
    .unit-price,
    .total-price,
    .bill-total-price {
      p {
        padding-left: 16px;
        color: #333333;
        font-family: 'PingFang SC-Regular';
        font-weight: 400;
        font-size: 14px;
      }
    }
  }

  .footer {
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 0px 0px 8px 8px;
    .btn-gray {
      background-color: #F5F7FA;
      color: #999999;
      border-color: #EEEEEE;
    }
    .btn-red {
      background-color: #F56C6C;
      color: white;
      border-color: #F56C6C;
    }
  }

  .red-dialog {
    .border {
      margin-bottom: 10px;
    }
    .dialog-footer {
      margin-top: 20px;
      border-top: 1px solid #f7f7f7;
      padding-top: 16px;
      display: flex;
      justify-content: center;
      .btn-white {
        margin-right: 20px;
      }
    }
  }
}

.messageBox420 .el-message-box__content .el-message-box__message {
  padding-left: 0px;
}
</style>
